import axiosNest from '../../api/axiosNest';

/**
 * „Sprawdź połączenie” z eco-truckiem (12.10.2026) — API
 * `eco-truck/connection-check.ts`. Wynik bez klucza i bez treści odpowiedzi
 * dostawcy.
 */
export type ConnectionStatus = 'ok' | 'unauthorized' | 'unreachable' | 'noCredential' | 'error';

export interface ConnectionCheck {
  status: ConnectionStatus;
  ok: boolean;
  /** Zdanie po polsku z API. */
  message: string;
  httpStatus: number | null;
  checkedAt: string;
}

export async function checkEcoTruckConnection(): Promise<ConnectionCheck> {
  const { data } = await axiosNest.post<ConnectionCheck>('/eco-truck/connection-check');
  return data;
}
